<template>
  <div>
    <el-card class="box-card">
      <div slot="header">
        <svg-icon iconName="water" style="color: #FFFFFF"/>
        {{ $t('Profile.waterUsageStatus') }}
      </div>
      <p class="mb-10" align="left">{{ $t('Profile.waterRegistrationID') }}: {{ currentProfile.waterNum }}</p>
      <p class="mb-10" align="left">{{ $t('Profile.meterNumber') }}: {{ profileData.meterNum }}</p>
      <p class="mb-10" align="left">{{ $t('Profile.address') }}: {{ profileData.address }}</p>
      <p class="mb-10" align="left">{{ $t('Profile.waterUsageOfMonth') }}: {{ profileData.usage }}{{ $t('Profile.m3') }}{{ $t('Profile.waterUsageDetail') }}:
        <span v-if="typeof profileData.status === 'string'">
          {{ $t(profileData.status) }}
        </span>
        <span v-else-if="typeof profileData.status === 'object'">
          {{ $t(profileData.status.key, profileData.status.params) }}
        </span>
      </p>
      <p class="mb-10" v-if="profileData.qualityDescription"  align="left">水質狀況: {{ profileData.qualityDescription }}</p>
    </el-card>

    <el-card class="box-card" v-loading="chartAreaLoading">
      <div slot="header" class="style-b">
        <el-button
            class="card-button"
            type="text"
            icon="el-icon-s-marketing"
            @click="showChart('History')"
            v-show="isShowHistoryBtn"
        >{{ $t('History.title') }}</el-button>
        <el-button
            class="card-button"
            type="text"
            icon="el-icon-s-marketing"
            @click="showChart('RecordComparison')"
            v-show="isShowRecordComparisonBtn"
        >{{ $t('RecordComparison.title') }}</el-button>
        <el-button
            class="card-button"
            type="text"
            icon="el-icon-s-data"
            @click="showChart('Record')"
            v-show="isShowRecordBtn"
        >{{ $t('Record.title') }}</el-button>
        <el-button
            class="card-button"
            type="text"
            icon="el-icon-s-marketing"
            @click="showChart('Trend')"
            v-show="isShowTrendBtn"
        >{{ $t('Trend.title') }}</el-button>
        <el-button
            class="card-button"
            type="text"
            icon="el-icon-s-data"
            @click="showChart('Situation')"
            v-show="isShowSituationBtn"
        >{{ $t('Situation.title') }}</el-button>
      </div>
      <div style="min-height: 520px">
        <Record v-if="chartType == 'Record'" :shareUVTU="shareUVTU"></Record>
        <RecordComparison v-if="chartType == 'RecordComparison'" :shareUVTU="shareUVTU"></RecordComparison>
        <Trend v-if="chartType == 'Trend'"></Trend>
        <History v-if="chartType == 'History'" :shareUVTU="shareUVTU"></History>
        <Situation v-if="chartType == 'Situation'"></Situation>
      </div>
    </el-card>

    <el-card v-if="profileData.qualityId" class="box-card">
      <div slot="header">
        <svg-icon iconName="water" style="color: #FFFFFF"/>
        水質狀況明細
      </div>
      <QualityDetail ></QualityDetail>
    </el-card>
    <FanReplacementStatus :show="frsDialog.show" :data="frsDialog.data" @close="frsDialogOnClose()"></FanReplacementStatus>
  </div>
</template>

<script>

import Record from '@/views/report/Record'
import RecordComparison from '@/views/report/RecordComparison'
import Trend from '@/views/report/Trend'
import History from '@/views/report/History'
import Situation from '@/views/report/Situation'
import QualityDetail from '@/views/report/QualityDetail'
import { viewRuleSetting } from '@/components/common'
import FanReplacementStatus from '@/views/FanReplacementStatus'

export default {
  // 用水狀況
  name: 'Profile',
  components: {
    Record,
    RecordComparison,
    Trend,
    History,
    Situation,
    QualityDetail,
    FanReplacementStatus,
  },
  data() {
    return {
      chartType: '',
      profileData: {
        address:undefined,
        usage:0,
        qualityId:undefined,
        flowDescription:undefined,
        qualityDescription:undefined,
        status:undefined,
        meterNum:undefined,
        activated:true, // 智慧水表中止用水判斷屬性
      },
      settingData: {
        viewType: '',
        waterId: '',
        immutable: false,
        usageViewTimeUnit: '',
        volumeViewTimeUnit: ''
      },
      shareUVTU: '',
      isShowHistoryBtn: false, //歷史曲線
      isShowSituationBtn: false, //用水情形
      isShowTrendBtn: false, //用水趨勢
      isShowRecordBtn: false, //用水量
      isShowRecordComparisonBtn: false, //用水量比較圖
      chartAreaLoading: false,  //圖表區塊Loading
      frsDialog: {
        show: false,
        data: [],
      }
    }
  },
  async created() {

  },
  // watch: {
  //   'settingData': {
  //     handler: function () {
  //       console.log('profile watch settingData:', this.settingData)
  //       this.shareUVTU = this.settingData.usageViewTimeUnit
  //       if (this.settingData.usageViewTimeUnit == 'hour') {
  //         this.isShowHistoryBtn = true
  //         this.isShowTrendBtn = true
  //       } else {
  //         this.isShowHistoryBtn = false
  //         this.isShowTrendBtn = false
  //       }
  //       if (this.settingData.usageViewTimeUnit == 'hour' || this.settingData.usageViewTimeUnit == 'day' || this.settingData.usageViewTimeUnit == 'week' || this.settingData.usageViewTimeUnit == 'month' ) {
  //         this.isShowSituationBtn = true
  //       } else {
  //         this.isShowSituationBtn = false
  //       }
  //     },
  //   }
  // },
  computed: {
    currentProfile() {
      //  this.getData()
      return JSON.parse(localStorage.getItem('currentProfile'))

    }
  },
  async mounted() {
    try {
      //  判斷是否顯示dialog call均彥API
      console.log('currentProfile:',this.currentProfile)
      this.chartAreaLoading = true  // 圖表區塊Loading - 開啟
      await this.getData()
      await this.showFrsDialog()  // 維護公告
      await this.getViewRule()
      this.shareUVTU = this.settingData.usageViewTimeUnit
      this.isShowRecordBtn = true  // 初始資料都拿到才顯示
      console.log('initial data finish')
      this.setTabDisplay()
      this.setDefaultChart()  // 依照用戶顯示管理設定決定預設顯示的圖表
      this.chartAreaLoading = false // 圖表區塊Loading - 關閉
    }catch (err) {
      console.log('err',err)
      this.chartAreaLoading = false // 圖表區塊Loading - 關閉
    }
  },
  methods: {
    async getViewRule() {
      this.settingData = await viewRuleSetting()
    },
    showChart(type) {
      console.log(type)
      this.chartType = type
    },
    setTabDisplay() {
      console.log('usageViewTimeUnit1:', this.settingData.usageViewTimeUnit)
      if (this.settingData.usageViewTimeUnit == 'hour') {
        this.isShowHistoryBtn = true  // 只有在設定為「正常」時，才顯示歷史曲線圖,20230913
        this.isShowTrendBtn = true
        // this.isShowRecordComparisonBtn = true
      } else {
        this.isShowHistoryBtn = false // 只有在設定為「正常」時，才顯示歷史曲線圖,20230913
        this.isShowTrendBtn = false
        // this.isShowRecordComparisonBtn = false
      }
      if (this.settingData.usageViewTimeUnit == 'hour' || this.settingData.usageViewTimeUnit == 'day' || this.settingData.usageViewTimeUnit == 'week' || this.settingData.usageViewTimeUnit == 'month' ) {
        this.isShowSituationBtn = true
        this.isShowRecordComparisonBtn = true
      } else {
        this.isShowSituationBtn = false
      }
    },
    // 依照用戶顯示管理設定決定預設顯示的圖表
    setDefaultChart() {
      // 用戶顯示管理設定為"年"時，顯示用水量查詢
      if (this.settingData.usageViewTimeUnit == 'year') {
        this.showChart('Record')
      } else {
        this.showChart('Situation')
      }
    },
    async getData()
    {

      console.log('login waterNum = ',this.currentProfile.waterNum)
      //http://localhost:8888/api/system/profile/waterNum/{waterNum}
      await this.axios.get('/api/system/profile/waterNum/' + this.currentProfile.waterNum ).then(res => {
        console.log('profile data = ',res.data)
        this.profileData.address = res.data.address
        this.profileData.meterNum = res.data.meterNum
        this.profileData.activated = res.data.activated // 智慧水表中止用水判斷屬性
      })

      //查本月用水量
      await this.axios.get('/api/report/profile/' + this.currentProfile.waterId + '/waterUsageComparison').then(res => {
        console.log('waterUsageComparison return = ',res.data)
        if (res.data.month)
          this.profileData.usage =res.data.month.toFixed(2)
      })

      //取得用戶水號的斷線狀態 (通訊狀態 及斷線天數)
      //GET /api/report/profileWithHeartBeat/{waterNum}
      await this.axios.get('/api/report/profileWithHeartBeat/' + this.currentProfile.waterNum ).then(res => {
        console.log('profileWithHeartBeat data = ',res.data)
        if (res.data.status == 'normal')
          this.profileData.status = 'Profile.waterUsageDetailNormal'
        if (res.data.status == 'lost'){
          // console.log('res.data.status lost =',true)
          // console.log('res.data.day =',res.data.day)
          if (res.data.day == null)
            this.profileData.status = 'Profile.waterUsageDetailLost'
          else
            this.profileData.status = {
                key: 'Profile.waterUsageDetailLostDays',
                params: { day: res.data.day }
            }
        }
        if (res.data.status == 'installed')
          this.profileData.status = 'Profile.waterUsageDetailInstalled'
        if (res.data.status == 'unknown')
          this.profileData.status = 'Profile.waterUsageDetailUnknown'

      }).catch(() => {
        // 由於此API發生錯誤會導致智慧用水中止功能異常，因此加入catch
        console.log('取得用戶水號的斷線狀態 失敗')
      })


      //由水號查詢monitorId , api/system/monitor/waterNum/水號
      await this.axios.get('/api/system/monitor/waterNum/' + this.currentProfile.waterNum ).then(res => {
        console.log('monitor data=',res.data)
        if (res.data.length > 0) {
          let data = res.data
          data.forEach(element => {
            let type = element.type // 紀錄日期格式化
            if (type =='Quality')
              this.profileData.qualityId = element.id
          });
        }
      })

      if (this.profileData.qualityId){
        // 濁度正常範圍: 濁度 <= 2 NTU   , res.data.data.cntu
        // 餘氯正常範圍:0.2mg/L <=餘氯<=1.0mg/L   ,res.data.data.cl
        // 酸鹼度正常範圍:6.0<=酸鹼度<=8.5, res.data.data.ph
        // 若不在正常範圍內，燈號顯示「維修中，暫停監測」
        //let url = "/api/report/monitor/" + item.id + "/rawdata"
        await this.axios.get('/api/report/monitor/' + this.profileData.qualityId+"/rawdata" ).then(res => {
          if (res.data.data.cntu<=2 && res.data.data.cl<=1 && res.data.data.ph<=8.5 && res.data.data.ph>=6 )
            this.profileData.qualityDescription ='安心使用'
          else
            this.profileData.qualityDescription = '維修中，暫停監測 '
        })
      }
    },
    async getFanReplacementStatus() {
     
      const res = await this.axios.get('/api/material/fan/replacement/status/' + this.currentProfile.waterId).catch(() => {
        console.log('get status error')
      })

      return res.data
    },
    async getActivatedByWaterNum() {
      const res = await this.axios.get('/api/system/profile/waterNum/' + this.currentProfile.waterNum ).catch(() => {
        console.log('get profile error')
      })

      return res.data.activated
    },
    // 顯示維護公告
    async showFrsDialog() {
      const _status = await this.getFanReplacementStatus()   // 智慧水表維護
      const _activated = this.profileData.activated  // 智慧水表終止用水
      if(_status === 'Running' || !_activated) {
        this.frsDialog.show = true
        this.frsDialog.data.push({
          waterId: this.currentProfile.waterId,
          waterNum: this.currentProfile.waterNum,
          status: _status,
          activated: _activated
        })
      }
    },
    // 傳輸設備維護公告關閉時觸發
    frsDialogOnClose() {
        this.frsDialog.show = false
        this.frsDialog.data = []
    }
  }
}
</script>
